export const encrypt = <T>(data: T): string => {
    const jsonString = JSON.stringify(data);
    return btoa(jsonString);
};

export const decrypt = <T>(encryptedData: string): T => {
    const jsonString = atob(encryptedData);
    return JSON.parse(jsonString) as T;
};